export default function stringRender(value) {
    return value;
}
